import { MainButton } from 'elements/button/MainButton';
import { DetailQuery_moment_cards_TwitterCard } from 'graphql/query/__generated__/DetailQuery';
import { useIsWide } from 'libs/utils/logic/ui/responsiveLogic';
import { useEffect, useState } from 'react';
import { TwitterEmbed } from 'react-social-media-embed';
import { Localization } from 'static/localization/localization';
import styled from 'styled-components/macro';

interface Props {
    card: DetailQuery_moment_cards_TwitterCard;
    className?: string;
}

export const TwitterCard = (props: Props): JSX.Element => {
    const [loading, setLoading] = useState(true);
    const postId = props.card.twitter.postId;
    const isWide = useIsWide();

    //For edit panel refresh
    useEffect(() => {
        setLoading(true);
        setTimeout(() => {
            setLoading(false);
        }, 50);
    }, [postId]);

    if (!postId) return <></>;

    return (
        <S_TwitterCard className={props.className}>
            {!loading && <TwitterEmbed url={postId} width={isWide ? 443 : 340} />}
            <S_Link href={postId} target="_blank" rel="noreferrer">
                <MainButton
                    type="event-secondary"
                    iconSet="far"
                    iconName="arrow-up-right-from-square"
                >
                    {Localization.OPEN_TWITTER}
                </MainButton>
            </S_Link>
        </S_TwitterCard>
    );
};

const S_TwitterCard = styled.div`
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
`;

const S_Link = styled.a`
    margin: 20px 0 0 0;
`;
